import { atomWithReset } from 'jotai/utils'

import { type StrategyMemo } from './hooks/useArchivedStrategyMemosInfiniteQuery'

type DialogInfo = {
  dialogType: 'delete'
  strategyMemo: StrategyMemo
}

export const dialogInfoAtom = atomWithReset<DialogInfo | undefined>(undefined)
